import { render } from "./EditTemplate.vue?vue&type=template&id=37cea057"
import script from "./EditTemplate.vue?vue&type=script&lang=js"
export * from "./EditTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__